<template>
    <b-sidebar
        v-model="localVisible"
        no-header
        backdrop
        sidebar-class="b-sidebar-bottom"
        @hidden="closeSidebar()"
    >
        <b-card class="border-0">
            <b-card-header class="bg-transparent p-2 border-0">
                <div
                    class="d-flex flex-column justify-content-center align-items-center">
                    <h2 class="mb-0">ขอจบงานนอกเวลา</h2>
                    <h5>ระบุรายละเอียดและเวลาในการจบงาน</h5>
                </div>
                <div>
                    <hr class="my-3" />
                </div>
            </b-card-header>
            <b-card-body class="p-2">
                <ValidationObserver ref="observer">
                    <b-form @submit="onSubmit">
                        <b-row>
                            <b-col lg="12">
                                <ValidationProvider rules="required" v-slot="{ errors }">
                                    <b-form-group label="ระบุเวลาจบงาน" label-for="input-time-end">
                                        <b-form-input 
                                            id="input-time-end" 
                                            placeholder="ระบุเวลาจบงาน" 
                                            v-model="form.time"
                                            type="datetime-local"
                                            :state="!errors.length ? null : false"
                                        >
                                        </b-form-input>
                                        <b-form-invalid-feedback>
                                            {{ errors[0] }}
                                        </b-form-invalid-feedback>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                            <b-col lg="12">
                                <ValidationProvider rules="required" v-slot="{ errors }">
                                    <b-form-group label="รายละเอียด" label-for="input-remark">
                                        <b-form-textarea
                                            id="input-remark" 
                                            v-model="form.remark"
                                            rows="3"
                                            max-rows="6"
                                            :state="!errors.length ? null : false"
                                        >
                                        </b-form-textarea>
                                        <b-form-invalid-feedback>
                                            {{ errors[0] }}
                                        </b-form-invalid-feedback>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                            <b-col lg="12">
                                <b-button
                                    variant="primary"
                                    block
                                    type="submit"
                                >
                                    ยืนยัน
                                </b-button>
                            </b-col>
                        </b-row>
                    </b-form>
                </ValidationObserver>
            </b-card-body>
        </b-card>
    </b-sidebar>
</template>

<script>
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { modalSuccess, modalError } from '@/util/alert.js'
import jobServices from "@/api/job.service.js";

export default {
    props: {
        isVisible: {
            type: Boolean
        }
    },
    components: {
        ValidationObserver,
        ValidationProvider,
    },
    data(){
        return {
            form: {
                time: null,
                remark: null
            },
            localVisible: this.isVisible
        }
    },
    methods: {
        async onSubmit(event){
            event.preventDefault();

            const isValid = await this.$refs.observer.validate();

            if (!isValid) {
                return;
            }

            try{
                const { data } = await jobServices.sendJobPartTime({
                    job_id: Number(this.$route.params.id),
                    time: this.form.time,
                    remark: this.form.remark
                });

                if(data){
                    modalSuccess(this.$bvModal, 'ขอจบงานนอกเวลาสำเร็จ')
                    this.closeSidebar();
                }
            }catch(err){}
        },
        closeSidebar(){
            this.$refs.observer.reset();
            this.localVisible = false;
            this.$emit('update:isVisible', false)
            this.form = {
                time: null,
                remark: null
            }
        }
    },
    watch: {
        isVisible(newVal) {
            this.localVisible = newVal;
        }
    },
}
</script>